import { ReactNode } from 'react';

import { RiMore2Fill } from '@remixicon/react';

import {
  ButtonIcon,
  Menu,
  MenuRoot,
  MenuRow,
} from '@spotify-internal/encore-web';
import { Popover } from '@spotify-internal/encore-web/next';

import styles from './ArtifactMenu.module.css';

interface RootProps {
  children: ReactNode;
  'aria-label': string;
  onOpen?: () => void;
}

const Root = ({ children, 'aria-label': ariaLabel, onOpen }: RootProps) => (
  <MenuRoot
    onOpenChange={isOpen => {
      if (isOpen) onOpen?.();
    }}
  >
    <ButtonIcon
      variant="tertiary"
      size="small"
      aria-label={ariaLabel}
      onClick={e => e.stopPropagation()}
    >
      <RiMore2Fill size={16} />
    </ButtonIcon>
    <Popover hasNoArrow onClick={e => e.stopPropagation()}>
      <Menu aria-label={ariaLabel}>{children}</Menu>
    </Popover>
  </MenuRoot>
);

interface ItemProps {
  icon: ReactNode;
  children: ReactNode;
  textValue: string;
  onClick?: () => void;
  destructive?: boolean;
  disabled?: boolean;
}

const Item = ({
  icon,
  children,
  textValue,
  onClick,
  destructive,
  disabled,
}: ItemProps) => (
  <MenuRow
    textValue={textValue}
    onAction={onClick}
    isDisabled={disabled}
    className={destructive ? styles.destructive : undefined}
  >
    {icon}
    {children}
  </MenuRow>
);

export const ArtifactMenu = {
  Root,
  Item,
};
